<template>
  <b-card no-body class="flex-container grid-stack-item-content">
    <div slot="header">
      <window-header :cmp-title="'Metrics for '+project.name" :widget-name="project.id+'metrics'"></window-header>
    </div>
    <div class="metrics-container flex-full-height">
      <svg ref="svg" class="h-100 w-100"></svg>
      <loading-overlay :show="loading"></loading-overlay>
    </div>
  </b-card>
</template>
<script>
  import { select } from 'd3-selection'
  import { axisBottom, axisLeft } from 'd3-axis'
  import { scaleLinear, schemeCategory10, scaleOrdinal } from 'd3-scale'
  import { extent } from 'd3-array'
  import { line as d3Line } from 'd3-shape'
  import WindowHeader from '../common/WindowHeader'
  import LoadingOverlay from '../LoadingOverlay'

  export default {
    name: 'project-metrics',
    components: {LoadingOverlay, WindowHeader},
    props: {
      project: {
        default: null
      }
    },
    data () {
      return {
        dataMetrics: [],
        loading: false
      }
    },
    mounted () {
      this.loading = true
      this.$http.get('/api/projects/metrics', {
        params: {
          workpack_id: this.project.workpack.id
        }
      }).then(res => {
        this.dataMetrics = res.body
        this.loading = false
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not load metrics',
          type: 'error'
        })
        this.loading = false
      })
    },
    computed: {
      resizeMap () {
        return this.$store.getters['map/widgetResizeMap'][this.project.id+'metrics']
      }
    },
    watch: {
      dataMetrics (val) {
        this.buildChart()
      },
      resizeMap () {
        console.log('resize map')
        this.buildChart()
      }
    },
    methods: {
      buildChart () {
        let svg = select(this.$refs.svg)
        svg.selectAll('*').remove()
        let bbox = this.$refs.svg.getBoundingClientRect()
        let paddingLeft = 10
        let paddingRight = 10
        let paddingBottom = 10
        let paddingTop = 10
        let width = bbox.width - paddingLeft - paddingRight
        let height = bbox.height - paddingBottom - paddingTop

        let scaleX = scaleLinear().domain([1, this.dataMetrics.length]).range([0, width])
        svg.append('g')
          .attr('transform', 'translate(' + paddingLeft + ',' + (bbox.height - paddingBottom) + ')')
          .call(axisBottom().scale(scaleX))

        let stats = [
          'total cost ($)',
          'total gathering corridor length (km)',
          '# of wells',
          '# of pads',
          'closest pad',
          'furthest pad',
          'total access track corridor length (km)',
          'area (ha) covered by drainage buffer',
          'number of wells in ramp',
          'SDR for gas',
          'SDR for water'
      ]

        let spacing = 10
        let heightStep = height / stats.length - spacing
        let c = scaleOrdinal(schemeCategory10)
        for (let i = 0; i < stats.length; i++) {
          let data = this.dataMetrics.filter(n => n[stats[i]]).map(n => parseFloat(n[stats[i]][0]))
          let startY = i * (heightStep) + (spacing * i) + paddingTop
          let ex = extent(data)
          if (ex[0] === ex[1]) {
            ex[0] = ex[0] - (ex[0] / 5)
            ex[1] = ex[1] + (ex[1] / 5)
          }
          let scaleY = scaleLinear().domain(ex).range([heightStep, 0])
          svg.append('g')
            .attr('transform', 'translate(' + paddingLeft + ',' + startY + ')')
            .call(axisLeft().scale(scaleY).tickValues([ex[0], (ex[0] + ex[1]) / 2, ex[1]]))

          let line = d3Line()
            .x(function (d, i) { return scaleX(i + 1) })
            .y(function (d) { return scaleY(d) })

          svg.append('g')
            .attr('transform', 'translate(' + paddingLeft + ',' + startY + ')')
            .datum(data)
            .append('path')
            .attr('class', 'metrics-line')
            .attr('stroke', c(i))
            .attr('d', line)

          svg.append('g')
            .attr('transform', 'translate(' + (paddingLeft + scaleX(data.length / 2)) + ',' + (startY + spacing) + ')')
            .append('text')
            .attr('class', 'metrics-label')
            .text(stats[i])
        }
      }
    }
  }
</script>
<style lang="scss">

  .metrics-container {
    width: 100%;
    height: 100%;
    /*background-color: lightgray;*/
    padding: 2rem;
  }

  .metrics-line {
    fill: none;
    stroke-width: 2px;
  }

  .metrics-label {
    font-size: 0.8rem;
    color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/projects/ProjectMatrics.vue